<!-- 创建时间2023/06/14 19:45:06 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：设置封面 -->
<template>
  <yxt-drawer :visible.sync="visible" size="960px" :title="$t('pc_biz_setCover'/** 设置封面 */)">
    <yxt-form label-width="120px">
      <yxt-form-item :label="$t('pc_kng_kngcourse_lbl_currentcover'/** 当前封面 */)">
        <img class="yxtbizf-br-4" :src="coverUrl" width="242" height="137" />
      </yxt-form-item>
      <yxt-form-item :label="$t('pc_kng_kngcourse_lbl_coverorign'/** 封面来源设置 */)">
        <div class="yxtbiz-flex-center pv10">
          <yxt-radio v-model="type" class="yxtbiz-mr12" :label="1">
            {{$t('pc_kng_kngcourse_lbl_usecover'/** 使用系统封面 */)}}
          </yxt-radio>
          <template v-if="type === 1">
            <yxt-button type="text" @click="change">{{ $t('pc_kng_kngcourse_btn_change'/** 换一换 */) }}</yxt-button>
            <yxt-button type="text" @click="select">{{ $t('pc_kng_kngcourse_btn_choose'/** 选一张 */) }}</yxt-button>
          </template>
        </div>
        <div class="yxtbiz-flex-center pv10">
          <yxt-radio v-model="type" class="yxtbiz-mr12" :label="0">
            {{ $t('pc_kng_kngcourse_btn_usecustomcovers'/** 使用自定义封面 */) }}
          </yxt-radio>
          <template v-if="type === 0">
            <yxt-button type="text" @click="upload">{{ $t('pc_kng_kngcourse_btn_uploadcover'/** 上传封面 */) }}</yxt-button>
            <yxt-button v-if="info.fileType" type="text" @click="designer">{{ $t('pc_kng_kngcourse_btn_designcover'/** 设计封面 */) }}</yxt-button>
          </template>
        </div>
        <div class="yxtbiz-flex-center pv10">
          <yxt-radio v-model="type" :label="3">{{ $t('pc_kng_kngcourse_btn_kngcovers'/** 使用课件类型封面 */) }}</yxt-radio>
        </div>
        <div class="yxtbiz-flex-center pv10" v-if="showSmartCover">
          <yxt-radio v-model="type" :label="4">
            {{ $t('pc_kng_kngcourse_btn_capacitycovers'/** 使用智能封面 */) }}
            <span class="standard-size-12 color-gray-6 break-word">{{ $t('pc_kng_kngcourse_btn_capacitycovers1'/** （视频使用内容中的一帧、文档使用内容首页作为课程封面） */) }}</span>
          </yxt-radio>
        </div>
      </yxt-form-item>
    </yxt-form>
    <div slot="footer">
      <yxt-button plain @click="cancel">{{ $t('pc_biz_comment_cancel'/** 取消 */) }}</yxt-button>
      <yxt-button type="primary" @click="confirm">{{ $t('pc_biz_common_btn_sure'/** 确定 */) }}</yxt-button>
    </div>
    <!-- 系统图片 -->
    <random-cover-drawer ref="random" />
    <!-- 上传封面 -->
    <yxtbiz-image-cropper
      :visible.sync="showCoverUpload"
      app-code="kng"
      module-name="knowledgefiles"
      function-name="CoverUpload"
      source="501"
      :size="imgSize"
      :suggest="{ w: 640, h: 360 }"
      filters=".jpg,.png"
      @complete="complete"
    ></yxtbiz-image-cropper>
  </yxt-drawer>
</template>

<script>
import {
  getImageShowAuthUrl,
  getImageShowImageUrl,
  getOrgParameter
} from 'yxt-biz-pc/packages/kng-operator/service';
import { KNG_FILE_TYPE } from 'yxt-biz-pc/packages/select-kng/src/const';
import randomCoverDrawer from './cover-radom-drawer.vue';
import { getDefaultKngTypeCover } from '../../../utils';
import commonUtil from 'yxt-biz-pc/packages/common-util';
export default {
  name: 'cover-drawer',
  inject: ['getInfo'],
  components: { randomCoverDrawer },
  data() {
    return {
      visible: false,
      showCoverUpload: false,
      type: 1,
      coverUrl: '',
      workId: '',
      imgSize: 1024
    };
  },
  computed: {
    info() {
      return this.getInfo();
    },
    showSmartCover() {
      const fileType = this.info.fileType;
      return [KNG_FILE_TYPE.VIDEO, KNG_FILE_TYPE.WORD, KNG_FILE_TYPE.PPT, KNG_FILE_TYPE.EXCEL, KNG_FILE_TYPE.PDF].includes(fileType);
    }
  },
  watch: {
    type(val) {
      if (val === 1) this.change();
      else if (val === 3) this.setKngTypeCover();
      else if (val === 4) this.setSmartCover();
    }
  },
  async created() {
    window.addEventListener('visibilitychange', this.handleImageShow);
    if (!window.CoverCap) {
      try {
        const res = await getOrgParameter('CoverCap', localStorage.orgId);
        window.CoverCap = Math.min(~~res.value || 1, 10);
      } catch (error) { }
    }
    this.imgSize = window.CoverCap * 1024;
  },
  beforeDestroy() {
    window.removeEventListener('visibilitychange', this.handleImageShow);
  },
  methods: {
    init(type, coverUrl) {
      return new Promise((resolve, reject) => {
        this.type = type === 2 ? 1 : type;
        this.coverUrl = coverUrl;
        this.visible = true;
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    confirm() {
      this.resolve({ type: this.type, coverUrl: this.coverUrl });
      this.visible = false;
    },
    cancel() {
      this.reject(new Error('cancel'));
      this.visible = false;
    },
    change() {
      this.coverUrl = this.$refs.random && this.$refs.random.getRandom();
    },
    upload() {
      this.showCoverUpload = true;
    },
    complete(src) {
      if (src) {
        this.coverUrl = src;
      }
    },
    designer() {
      const params = {
        knowledgeId: this.info.id || '',
        workId: this.workId || this.info.coverId || ''
      };
      console.log(params);
      getImageShowAuthUrl(params).then(res => {
        if (res.workId) {
          this.workId = res.workId;
        }
        if (res.url) {
          this.openImagesShow = true;
          window.open(res.url);
        }
      });
    },
    handleImageShow() {
      if (
        document.visibilityState !== 'hidden' &&
        this.visible &&
        this.openImagesShow &&
        this.type === 0 &&
        this.workId
      ) {
        getImageShowImageUrl(this.workId).then(res => {
          if (res.url) {
            this.coverUrl = res.url;
            this.openImagesShow = false;
          }
        });
      }
    },
    select() {
      this.$refs.random.init().then(res => {
        this.coverUrl = res;
      });
    },
    setKngTypeCover() {
      this.coverUrl = getDefaultKngTypeCover(this.info.fileType);
    },
    setSmartCover() {
      if (commonUtil.getLanguage() === 'en') {
        this.coverUrl = this.$staticBaseUrl + 'ufd/55a3e0/kng/pc/img/smart_en.png';
      } else {
        this.coverUrl =
        this.$staticBaseUrl + 'ufd/407a24/kng/pc/img/images/smart.png';
      }
    }
  }
};
</script>